import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';

export const apiPrefixInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.startsWith('api/')) {
    const base = environment.apiUrl.replace(/\/$/, '');
    req = req.clone({ url: `${base}/${req.url}` });
  }
  return next(req);
};
